import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CommitteeSelectionModalComponent } from '../committee-selection-modal/committee-selection-modal.component';

@Component({
  selector: 'app-enhanced-committee-field',
  standalone: false,
  templateUrl: './enhanced-committee-field.component.html',
  styleUrls: ['./enhanced-committee-field.component.scss'],
})
export class EnhancedCommitteeFieldComponent implements OnInit {

  @Input() pageSpecificFormObject: any;
  @Input() committeeList: any[] = [];
  @Input() canUpdate: boolean = false;

  constructor(private modalController: ModalController) { }

  ngOnInit() {
    console.log('EnhancedCommitteeField - canUpdate:', this.canUpdate);
    console.log('EnhancedCommitteeField - committeeList:', this.committeeList);
  }

  /**
   * Get array of selected committee objects
   */
  getSelectedCommittees(): any[] {
    if (!this.pageSpecificFormObject?.committeIds || !this.committeeList) {
      return [];
    }

    return this.committeeList.filter(committee =>
      this.pageSpecificFormObject.committeIds.includes(String(committee.id))
    );
  }

  /**
   * Remove a single committee from selection
   */
  removeCommittee(committeeId: any): void {
    if (!this.pageSpecificFormObject?.committeIds) {
      return;
    }

    const idString = String(committeeId);
    // Create a new array to trigger change detection
    this.pageSpecificFormObject.committeIds = this.pageSpecificFormObject.committeIds.filter(
      id => id !== idString
    );
  }

  /**
   * Clear all committee selections
   */
  clearAllCommittees(): void {
    if (this.pageSpecificFormObject) {
      this.pageSpecificFormObject.committeIds = [];
    }
  }

  /**
   * Get count of selected committees
   */
  get selectedCount(): number {
    return this.pageSpecificFormObject?.committeIds?.length || 0;
  }

  /**
   * Check if any committees are selected
   */
  get hasSelections(): boolean {
    return this.selectedCount > 0;
  }

  /**
   * Check if committee list is empty
   */
  get hasCommittees(): boolean {
    return this.committeeList && this.committeeList.length > 0;
  }

  /**
   * Get label text for the field
   */
  get fieldLabel(): string {
    if (this.selectedCount > 0) {
      return `Committee (${this.selectedCount} selected)`;
    }
    return 'Committee';
  }

  /**
   * Open committee selection modal
   */
  async openSelectionModal(): Promise<void> {
    const modal = await this.modalController.create({
      component: CommitteeSelectionModalComponent,
      componentProps: {
        allCommittees: this.committeeList,
        selectedCommitteeIds: this.pageSpecificFormObject?.committeIds || []
      },
      cssClass: 'committee-selection-modal',
      backdropDismiss: true
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm' && data) {
      // Update the form object with selected IDs
      this.pageSpecificFormObject.committeIds = data.selectedIds;
      console.log('Committees updated:', data.selectedIds);
    }
  }

}
